import axios from 'axios';
import { useSelector } from 'react-redux';
import { getStorageItem } from 'services/storage';
import { getApiUrlDomain, getToken } from 'store/services/session/selectors';
import { STORAGE_KEY } from 'constants/browserStorageKeys';
import { debounce } from 'lodash';
import { useState } from 'react';
import { Option } from 'types';

export const useAutocomplete = () => {
  const [defaultOptions, setDefaultOptions] = useState({});

  const token = useSelector(getToken);
  const apiUrlDomain = useSelector(getApiUrlDomain);

  const onLoadAutocompleteOptions = debounce(
    (
      id: string,
      searchString: string,
      query: string,
      callback: (options: Option[]) => void,
    ) => {
      const session_id = getStorageItem(STORAGE_KEY.SESSION_ID);

      axios({
        method: 'post',
        url: `https://${apiUrlDomain}/chat/autocomplete`,
        data: {
          session_id,
          field_id: id,
          search_for: searchString,
          ...(query && { value: query }),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(response => {
        const options = response?.data?.options || [];

        callback(options);
        setDefaultOptions({ [id]: options });
      });
    },
    500,
  );
  return { defaultOptions, onLoadAutocompleteOptions };
};
